import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { Icon, Pagination } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
  ContainerPaginate,
} from "./styled";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import ScrollingModal from "../../../../../components/Admin/Pocketbook/parceiros/listagem/ModalSolicitacoesParceiros";
import Back from "../../../../../components/Admin/Pocketbook/parceiros/Criar/Back";
import { Box } from "@material-ui/core";

const ListagemSolicitacoesParceiros = (props) => {
  const [solicitacoesParceiros, setSolicitacoesParceiros] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [pages, setPages] = useState(0);

  useEffect(() => {
    loadSolicitacoesParceiros();
  }, [currentPage]);

  const loadSolicitacoesParceiros = useCallback(async () => {
    try {
      const params = {
        page: currentPage,
      };

      if (search) {
        params.search = search;
      }

      const response = await api.get("/pb4y-listagem-solicitacoes-parceiros", {
        params,
      });
      const { solicitacoesParceiros, count } = response.data;

      let array = {
        local: "parceirosPocket",
        texto: `listou as Solicitações de parceira do pocket`,
      };
      await api.post("system_logs", { acao: JSON.stringify(array) });
      console.log(solicitacoesParceiros);
      setSolicitacoesParceiros(solicitacoesParceiros);
      setPages(count);
    } catch (err) {
      console.error(err);
      swal("Não foi possível carregar as Solicitações", "", "").then((res) =>
        props.history.push("/")
      );
    }
  }, [currentPage, search]);

  const status = [
    { texto: "Não iniciado" },
    { texto: "Em andamento" },
    { texto: "Finalizado" },
  ];

  return (
    <Box width="100%" paddingLeft="250px">
    <Box width="100%" padding="1rem">
        <AdminMenu />
        <Content>
          <Back />
          <Title>Listagem de solicitação de parceiros</Title>

          <ContainerInputSearch className="ui fluid left icon input">
            <Input
              type="search"
              placeholder="Procurar Solicitacao"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Icon name="search icon" />

            <CreateButton onClick={loadSolicitacoesParceiros}>
              Procurar
            </CreateButton>
          </ContainerInputSearch>

          <SemanticTable size="big" celled>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>
                  Nome do parceiro
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>E-mail</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Whatsapp</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>instagram</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>blog</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Tipo de parceria
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Andamento</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  editar andamento
                </SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>
            <SemanticTable.Body>
              {solicitacoesParceiros?.map((solicitacao, index) => (
                <SemanticTable.Row key={index}>
                  <SemanticTable.Cell>{solicitacao.nome}</SemanticTable.Cell>
                  <SemanticTable.Cell>{solicitacao.email}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {solicitacao.telefone}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {solicitacao.instagram}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>{solicitacao.blog}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {solicitacao.tipo === 2 ? "Influenciador" : "Blog"}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {status[solicitacao.status - 1].texto}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <ScrollingModal parceiro={solicitacao.nome} />
                  </SemanticTable.Cell>
                </SemanticTable.Row>
              ))}
            </SemanticTable.Body>
          </SemanticTable>
          <ContainerPaginate>
            <Pagination
              defaultActivePage={1}
              ellipsisItem={null}
              // siblingRange={1}
              totalPages={pages}
              onPageChange={(e, f) => setCurrentPage(f.activePage)}
              page={currentPage}
            />
          </ContainerPaginate>
        </Content>
      </Box>
    </Box>
  );
};

export default withRouter(ListagemSolicitacoesParceiros);
